module.exports = __webpack_public_path__ + "img/download-bold-svgrepo-com 1.665ae619.svg";